import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DocumentFolder, DocumentFolderCreate, DocumentFolderFilter } from '../data/documentFolder';

export function createDocumentFolderService(client: AxiosInstance) {
  return createCrudService<DocumentFolder, DocumentFolderCreate, DocumentFolderFilter>(
    client,
    '/document-management/DocumentFolder',
    'id',
  );
}

export type DocumentFolderService = CrudService<DocumentFolder, DocumentFolderCreate, DocumentFolderFilter>;
